import { createSlice } from '@reduxjs/toolkit';
import { AI_WORKFLOW_TYPES } from '../aiWorkflow/constants';

const NOTIFICATIONS = 'notifications';

const WORKFLOW_KEYS = Object.keys(AI_WORKFLOW_TYPES);

const loadState = () => {
	const storageValue = localStorage.getItem(NOTIFICATIONS);
	let parsedJson = {};
	try {
		parsedJson = storageValue ? JSON.parse(storageValue) : {};
	} catch (e) {
		localStorage.removeItem(NOTIFICATIONS);
	}

	return {
		...parsedJson,
	};
};

const updateLocalStorage = (state) => {
	const { aiWorkflows } = state;
	localStorage.setItem(
		NOTIFICATIONS,
		JSON.stringify({
			aiWorkflows,
		}),
	);
};

export const notificationsSlice = createSlice({
	name: NOTIFICATIONS,
	initialState: loadState(),
	reducers: {
		addAIWorkflows: (state, action) => {
			const { userId, type, id } = action.payload;

			if (!WORKFLOW_KEYS.includes(type)) return;

			const newTime = Date.now();

			const existingUserViews = {
				...AI_WORKFLOW_TYPES.reduce((acc, v) => ({ ...acc, [v]: [] })),

				...(state.recentlyViewed[userId] ?? {}),
			};

			const list = [
				...(existingUserViews[type] ?? []).slice().filter((item) => item.id !== id),
				{ id, time: newTime },
			];

			state.aiWorkflows[userId] = { ...existingUserViews, [type]: list };

			updateLocalStorage(state);
		},
		removeAIWorkflows: (state, action) => {
			const { userId, type, id } = action.payload;
			if (!userId || !id) return;
			if (!WORKFLOW_KEYS.includes(type)) return;

			const existingUserViews = state.aiWorkflows[userId];
			if (!existingUserViews || !existingUserViews[type]) return;

			const updatedList = existingUserViews[type].filter((item) => item.id !== id);

			state.aiWorkflows[userId] = {
				...existingUserViews,
				[type]: updatedList,
			};

			updateLocalStorage(state);
		},
	},
});

export const { addAIWorkflows, removeAIWorkflows } = notificationsSlice.actions;

export default notificationsSlice.reducer;
